import DefaultProfileImageSrc from 'src/assets/images/default_profile.jpeg';

export default function getProfileImg(profileImg: string | null | undefined) {
  if (profileImg) {
    return `${process.env.REACT_APP_API_URL}/upload/${profileImg}`;
  }
  return DefaultProfileImageSrc;
}
